import { render } from "./BaseLoading.vue?vue&type=template&id=6cbb122f"
import script from "./BaseLoading.vue?vue&type=script&lang=js"
export * from "./BaseLoading.vue?vue&type=script&lang=js"

import "./BaseLoading.vue?vue&type=style&index=0&id=6cbb122f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__